/*
 * @Description:
 * @Author: Harry
 * @Date: 2020-11-18 15:56:48
 * @LastEditTime: 2020-12-08 10:33:19
 * @LastEditors: Harry
 */
import fetch from "@/utils/request";


export default {
  getBankList(data?: object, config = {}): any {
    return fetch({
      url: "/php/api/bankcard/bank_list",
      method: "get",
      data,
      ...config
    });
  },

  addBankCard(data?: object): any {
    return fetch({
      url: "/php/api/bankcard/add_bank",
      method: "post",
      data
    });
  },

  delBankCard(data?: object): any {
    return fetch({
      url: "/php/api/bankcard/del_bank",
      method: "post",
      data
    });
  },

  getBankCardInfo(data?: object): any {
    return fetch({
      url: "/php/api/bankcard/bank_info",
      method: "get",
      data
    });
  }
};
